module.exports = __webpack_public_path__ + "img/home_collections_fr.dfaf763.png";